// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/**
 * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/*
* Ensure proper alignment of the vue material icons
*/
.material-design-icon[data-v-d81f7625] {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
.nc-button-group-base > div[data-v-d81f7625] {
  text-align: center;
  color: var(--color-text-maxcontrast);
}
.nc-button-group-base ul.nc-button-group-content[data-v-d81f7625] {
  display: flex;
  gap: 4px;
  justify-content: space-between;
}
.nc-button-group-base ul.nc-button-group-content[data-v-d81f7625] li {
  flex: 1 1;
}
.nc-button-group-base ul.nc-button-group-content[data-v-d81f7625] .action-button {
  padding: 0 !important;
  width: 100%;
  display: flex;
  justify-content: center;
}
.nc-button-group-base ul.nc-button-group-content[data-v-d81f7625] .action-button.action-button--active {
  background-color: var(--color-primary-element);
  border-radius: var(--border-radius-large);
  color: var(--color-primary-element-text);
}
.nc-button-group-base ul.nc-button-group-content[data-v-d81f7625] .action-button.action-button--active:hover, .nc-button-group-base ul.nc-button-group-content[data-v-d81f7625] .action-button.action-button--active:focus, .nc-button-group-base ul.nc-button-group-content[data-v-d81f7625] .action-button.action-button--active:focus-within {
  background-color: var(--color-primary-element-hover);
}
.nc-button-group-base ul.nc-button-group-content[data-v-d81f7625] .action-button .action-button__pressed-icon {
  display: none;
}`, "",{"version":3,"sources":["webpack://./node_modules/@nextcloud/vue/dist/assets/NcActionButtonGroup-CRXLyFpx.css"],"names":[],"mappings":"AAAA;;;EAGE;AACF;;;EAGE;AACF;;CAEC;AACD;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,oCAAoC;AACtC;AACA;EACE,aAAa;EACb,QAAQ;EACR,8BAA8B;AAChC;AACA;EACE,SAAS;AACX;AACA;EACE,qBAAqB;EACrB,WAAW;EACX,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,8CAA8C;EAC9C,yCAAyC;EACzC,wCAAwC;AAC1C;AACA;EACE,oDAAoD;AACtD;AACA;EACE,aAAa;AACf","sourcesContent":["/**\n * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/**\n * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/*\n* Ensure proper alignment of the vue material icons\n*/\n.material-design-icon[data-v-d81f7625] {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n.nc-button-group-base > div[data-v-d81f7625] {\n  text-align: center;\n  color: var(--color-text-maxcontrast);\n}\n.nc-button-group-base ul.nc-button-group-content[data-v-d81f7625] {\n  display: flex;\n  gap: 4px;\n  justify-content: space-between;\n}\n.nc-button-group-base ul.nc-button-group-content[data-v-d81f7625] li {\n  flex: 1 1;\n}\n.nc-button-group-base ul.nc-button-group-content[data-v-d81f7625] .action-button {\n  padding: 0 !important;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n}\n.nc-button-group-base ul.nc-button-group-content[data-v-d81f7625] .action-button.action-button--active {\n  background-color: var(--color-primary-element);\n  border-radius: var(--border-radius-large);\n  color: var(--color-primary-element-text);\n}\n.nc-button-group-base ul.nc-button-group-content[data-v-d81f7625] .action-button.action-button--active:hover, .nc-button-group-base ul.nc-button-group-content[data-v-d81f7625] .action-button.action-button--active:focus, .nc-button-group-base ul.nc-button-group-content[data-v-d81f7625] .action-button.action-button--active:focus-within {\n  background-color: var(--color-primary-element-hover);\n}\n.nc-button-group-base ul.nc-button-group-content[data-v-d81f7625] .action-button .action-button__pressed-icon {\n  display: none;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
